export default __webpack_public_path__ + "static/media/fastlane_detail3.b0ca08f6.jpg";